import invariant from 'tiny-invariant'
import { Currency } from './currency'
import { NativeCurrency } from './nativeCurrency'
import { Token } from './token'
import { SAMB } from './samb'

/**
 * AMB is the main usage of a 'native' currency
 */
export class Amber extends NativeCurrency {
  protected constructor(chainId: number) {
    super(chainId, 18, 'AMB', 'AMBER')
  }

  public get wrapped(): Token {
    const SAMBT = SAMB[this.chainId]
    invariant(!!SAMBT, 'WRAPPED')
    return SAMBT
  }

  private static _etherCache: { [chainId: number]: Amber } = {}

  public static onChain(chainId: number): Amber {
    return this._etherCache[chainId] ?? (this._etherCache[chainId] = new Amber(chainId))
  }

  public equals(other: Currency): boolean {
    return other.isNative && other.chainId === this.chainId
  }
}
